// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"31f97508","566":"7d06d240","963":"be01dccb","988":"b1a19f90"}[chunkId] + ".chunk.js";
};